import * as Types from '../../../generated/index'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type AiChatDefaultAgentWelcomeMessageQueryVariables = Types.Exact<{ [key: string]: never }>

export type AiChatDefaultAgentWelcomeMessageQuery = {
  aiChatDefaultAgentWelcomeMessage?: string | null
}

export const AiChatDefaultAgentWelcomeMessageDocument = gql`
  query aiChatDefaultAgentWelcomeMessage {
    aiChatDefaultAgentWelcomeMessage
  }
`

/**
 * __useAiChatDefaultAgentWelcomeMessageQuery__
 *
 * To run a query within a React component, call `useAiChatDefaultAgentWelcomeMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiChatDefaultAgentWelcomeMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiChatDefaultAgentWelcomeMessageQuery({
 *   variables: {
 *   },
 * });
 */
export function useAiChatDefaultAgentWelcomeMessageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AiChatDefaultAgentWelcomeMessageQuery,
    AiChatDefaultAgentWelcomeMessageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AiChatDefaultAgentWelcomeMessageQuery,
    AiChatDefaultAgentWelcomeMessageQueryVariables
  >(AiChatDefaultAgentWelcomeMessageDocument, options)
}
export function useAiChatDefaultAgentWelcomeMessageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AiChatDefaultAgentWelcomeMessageQuery,
    AiChatDefaultAgentWelcomeMessageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AiChatDefaultAgentWelcomeMessageQuery,
    AiChatDefaultAgentWelcomeMessageQueryVariables
  >(AiChatDefaultAgentWelcomeMessageDocument, options)
}
export function useAiChatDefaultAgentWelcomeMessageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AiChatDefaultAgentWelcomeMessageQuery,
        AiChatDefaultAgentWelcomeMessageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AiChatDefaultAgentWelcomeMessageQuery,
    AiChatDefaultAgentWelcomeMessageQueryVariables
  >(AiChatDefaultAgentWelcomeMessageDocument, options)
}
export type AiChatDefaultAgentWelcomeMessageQueryHookResult = ReturnType<
  typeof useAiChatDefaultAgentWelcomeMessageQuery
>
export type AiChatDefaultAgentWelcomeMessageLazyQueryHookResult = ReturnType<
  typeof useAiChatDefaultAgentWelcomeMessageLazyQuery
>
export type AiChatDefaultAgentWelcomeMessageSuspenseQueryHookResult = ReturnType<
  typeof useAiChatDefaultAgentWelcomeMessageSuspenseQuery
>
export type AiChatDefaultAgentWelcomeMessageQueryResult = Apollo.QueryResult<
  AiChatDefaultAgentWelcomeMessageQuery,
  AiChatDefaultAgentWelcomeMessageQueryVariables
>
